import { render } from "./CreateMaterialModal.vue?vue&type=template&id=f7fe4ba2"
import script from "./CreateMaterialModal.vue?vue&type=script&lang=js"
export * from "./CreateMaterialModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__